(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/dialog/assets/javascripts/.trinidad/views/confirm.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/dialog/assets/javascripts/.trinidad/views/confirm.trinidad.js'); "use strict";

(() => {

  "use strict";


  var __webpack_require__ = {};





  (() => {

    __webpack_require__.n = module => {
      var getter = module && module.__esModule ?
      () => module['default'] :
      () => module;

      __webpack_require__.d(getter, {
        a: getter
      });


      return getter;
    };

  })();





  (() => {

    __webpack_require__.d = (exports, definition) => {
      for (var key in definition) {
        if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
          Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }

      }

    };

  })();





  (() => {
    __webpack_require__.g = function () {
      if (typeof globalThis === 'object') return globalThis;

      try {
        return this || new Function('return this')();
      } catch (e) {
        if (typeof window === 'object') return window;
      }

    }();

  })();





  (() => {
    __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);

  })();



  var __webpack_exports__ = {}; 

  __webpack_require__.d(__webpack_exports__, {
    "default": () =>
    views_confirm
  });

  ; 

  const external_gsap_namespaceObject = window["gsap"];

  var external_gsap_default = __webpack_require__.n(external_gsap_namespaceObject);

  ; 


  class PubSub {
    constructor() {
      this.callbacks = {};
    }

    emit(event, data) {
      if (this.callbacks[event]) {
        this.callbacks[event].forEach(callback => {
          callback.callback.call(callback.context || this, data);
        });
      }
    }

    on(event, context, callback) {
      if (typeof context === 'function') {
        callback = context;
        context = undefined;
      }

      if (!this.callbacks[event]) {
        this.callbacks[event] = [];
      }

      this.callbacks[event].push({
        context,
        callback
      });
    }

    off(event, context) {
      context = context || this;

      if (this.callbacks[event]) {
        for (let i = 0; i < this.callbacks[event].length; i++) {
          const item = this.callbacks[event][i];

          if (item.context === context) {
            this.callbacks[event].splice(i, 1);
            break;
          }
        }
      }
    }

  }


  const pubsub = PubSub;
  ; 

  const external_svs_ui_namespaceObject = window["svs"]["ui"];
  ; 


  const CONFIRM = 'confirm';
  const ERROR = 'error';
  const DEFAULT = CONFIRM;

  const type = {
    CONFIRM,
    DEFAULT,
    ERROR
  };
  ; 


  const PRIMARY = 'primary';
  const SECONDARY = 'secondary';

  const constants_button = {
    PRIMARY,
    SECONDARY
  };
  ; 


  class DialogButtons extends pubsub {
    constructor(options) {
      super();
      this.log = window.svs ? new window.svs.core.log.Logger('DialogButtons') : console;
      this.options = options; 

      this.scrollButtonVisible = false;
      this.buttons = [];
      this.focusCount = 0; 

      this.defineTypes();
      this.render();
    }

    defineTypes() {
      if (this.options.type === ERROR && this.options.actions.length !== 1) {
        this.log.error('Only 1 action is allowed in an error message.');
      }

      if (this.options.actions) {
        switch (this.options.actions.length) {
          case 1:
            this.options.actions[0].type = SECONDARY;
            break;

          case 2:
            this.options.actions[0].type = SECONDARY;
            this.options.actions[1].type = PRIMARY;
            break;

          default:
            this.log.error('You must define atleast 1 or 2 actions.');
            break;
        }
      }
    }

    addScrollButton() {
      this._scrollButton = document.createElement('button');
      this._scrollButton.className += 'dialog-button dialog-button-primary js-dialog-button-scrollable dialog-button-scrollable';

      this._scrollButton.setAttribute('title', 'Gå till slutet');

      this._scrollButton.innerHTML = "<i class=\"icon icon-200 icon-menu-down fc-white\"></i>";
      new external_svs_ui_namespaceObject.RippleEffect(this._scrollButton, () => {
        this.emit('scrollToEnd');
      });
      this.el.appendChild(this._scrollButton);
    }

    hideScrollButton() {
      if (this.scrollButtonVisible) {
        this.log.debug('Hide Scroll Button');
        external_gsap_default().to(this.buttonsEl, {
          duration: 0.2,
          y: 0,
          onComplete: () => {
            if (this.focusCount > 0) {
              this.setFocus();
            }
          }
        });
        external_gsap_default().to(this._scrollButton, {
          duration: 0.2,
          y: 100
        });
        this.scrollButtonVisible = false;
      }
    }

    showScrollButton() {
      if (!this.scrollButtonVisible) {
        if (!this._scrollButton) {
          this.addScrollButton();
        }

        this.log.debug('Show Scroll Button');
        external_gsap_default().to(this.buttonsEl, {
          duration: 0.2,
          y: 100
        });
        external_gsap_default().to(this._scrollButton, {
          duration: 0.2,
          y: 0,
          onComplete: () => {
            if (this.focusCount > 0) {
              this.setFocus();
            }
          }
        });
        this.scrollButtonVisible = true;
      }
    }

    toggleTabIndex() {
      if (this.scrollButtonVisible) {
        this.buttons.forEach(button => {
          button.tabIndex = -1;
        });
        this._scrollButton.tabIndex = 0;
      } else {
        this.buttons.forEach(button => {
          button.tabIndex = 0;
        });

        if (this._scrollButton) {
          this._scrollButton.tabIndex = -1;
        }
      }
    }

    setFocus() {
      document.activeElement && document.activeElement.blur();
      let btn;

      if (!this.scrollButtonVisible) {
        btn = this.buttons[this.buttons.length - 1];
      } else {
        btn = this._scrollButton;
      }

      if (btn) {
        this.toggleTabIndex();
      } 


      this.focusCount++;
    }

    showLoader(e) {
      this.buttons.forEach(button => {
        button.setAttribute('disabled', 'disabled');
      });
      const btnWidth = e.target.clientWidth - 24; 

      e.target.innerHTML = '';
      e.target.insertAdjacentHTML('afterbegin', "<div class=\"js-dialog-loader\" style=\"width: ".concat(btnWidth, "px\"></div>"));
      const loader = new external_svs_ui_namespaceObject.Loader(e.target.querySelector('.js-dialog-loader'));
      loader.show(200, 'default');
    }

    createButtonContainer() {
      this.el = document.createElement('div');
      this.el.className += 'dialog-button-container';
    }

    createButtonWrapper() {
      this.buttonsEl = document.createElement('div');
      this.buttonsEl.className += 'dialog-buttons js-dialog-buttons';
    }

    createButtons() {
      if (this.options.actions) {
        this.options.actions.forEach(action => {
          const callback = action.callback; 

          const _button = document.createElement('button');

          _button.className += "dialog-button dialog-button-".concat(action.type);
          _button.innerText = action.title; 

          new external_svs_ui_namespaceObject.RippleEffect(_button, e => {
            if (_button.clicked) {
              this.log.debug('Prevented double-click');
              return;
            }

            this.log.debug('Clicked a button');
            _button.clicked = true;
            let delayLoader = 0;

            if (action.showLoader) {
              this.showLoader(e);
              delayLoader = 500;
            }

            if (callback) {
              setTimeout(() => {
                this.emit('callback', {
                  e,
                  callback
                });
              }, delayLoader);
            } else {
              this.emit('close');
            }

            setTimeout(() => {
              _button.clicked = false;
            }, 500);
          });
          this.buttonsEl.appendChild(_button);
          this.buttons.push(_button);
        });
      }
    }

    render() {
      this.createButtonContainer();
      this.createButtonWrapper();
      this.el.appendChild(this.buttonsEl);
      this.createButtons();
    }

  }


  const buttons = DialogButtons;
  ; 


  const TEXT = 'text';
  const HREF = 'link';
  const CHECKBOX = 'checkbox';
  const ALIGN_LEFT = 'align-left';
  const ALIGN_CENTER = 'align-center';
  const ALIGN_RIGHT = 'align-right';

  const message = {
    TEXT,
    HREF,
    CHECKBOX,
    align: {
      LEFT: ALIGN_LEFT,
      CENTER: ALIGN_CENTER,
      RIGHT: ALIGN_RIGHT
    }
  };
  ; 


  class DialogMessageIcon extends pubsub {
    constructor(icon) {
      super();
      this.log = window.svs ? new window.svs.core.log.Logger('DialogMessageIcon') : console;
      this.createIconWrapper(icon);
    }

    createIconWrapper(icon) {
      this.el = document.createElement('div');
      this.el.className += 'dialog-icon ';
      this.el.innerHTML = "<i class=\"icon icon-default icon-".concat(icon, "\"></i>");
    }

  }


  const icon = DialogMessageIcon;
  ; 


  class DialogContent extends pubsub {
    constructor(options) {
      super();
      this.log = window.svs ? new window.svs.core.log.Logger('DialogContent') : console;
      this.options = options;
      this.hasScrollbar = false;
      this.scrolledBottom = null;
      this.render();
    }

    addMessageRow(message, i) {
      const messageRow = document.createElement('div');
      messageRow.className += "dialog-message-row dialog-message-".concat(message.type);

      switch (message.type) {
        case CHECKBOX:
          if (message.block) {
            messageRow.className += '-block';
          }

          messageRow.innerHTML = "<div class=\"form-toggle\">\n          <input type=\"checkbox\" value=\"".concat(message.value, "\" ").concat(message.checked && 'checked="checked"', "\n            class=\"form-toggle-input form-toggle-checkbox form-toggle-default js-dialog-item-checkbox\" id=\"").concat(message.id ? message.id : i, "\" name=\"checkbox[]\">\n          <label class=\"form-label form-label-align-left\" for=\"").concat(message.id ? message.id : i, "\">\n              <span class=\"form-label-btn\"></span>\n              <span class=\"form-label-text\">").concat(message.text, "</span>\n          </label>\n        </div>");
          break;

        default:
          messageRow.innerHTML = message.text;
          break;
      }

      if (message.align) {
        messageRow.className += " ".concat(message.align);
      }

      return messageRow;
    }

    updateScrollPosition() {
      if (Math.ceil(this.el.scrollTop) >= this.el.scrollHeight - this.el.offsetHeight) {
        if (!this.scrolledBottom) {
          this.emit('contentBottom');
          this.scrolledBottom = true;
        }
      } else if (this.scrolledBottom === null || this.scrolledBottom) {
        this.emit('contentScrolling');
        this.scrolledBottom = false;
      }
    }

    addScrollListener() {
      this.el.onscroll = () => {
        this.updateScrollPosition();
      };
    }

    removeScrollListener() {
      this.el.onscroll = null;
    }

    testScrollArea() {
      if (this.el.scrollHeight - this.el.offsetHeight) {
        if (!this.hasScrollbar) {
          this.addScrollListener();
          this.hasScrollbar = true;
        }
      } else if (this.hasScrollbar) {
        this.removeScrollListener();
        this.hasScrollbar = false;
      }

      this.updateScrollPosition();
    }

    scrollToEnd() {
      const scrollToPosition = this.el.scrollHeight - this.el.offsetHeight;
      external_gsap_default().to(this.el, {
        duration: 0.3,
        scrollTop: scrollToPosition
      });
    }

    filterAcceptedMessages(m) {
      return m.text.length;
    }

    createButtonWrapper() {
      this.el = document.createElement('div');
      this.el.className += 'dialog-content js-dialog-content focus-default';
      this.el.tabIndex = -1;
    }

    addIcon() {
      if (this.options.icon) {
        this._icon = new icon(this.options.icon);
        this.el.appendChild(this._icon.el);
      }
    }

    createTextWrapper() {
      this._textEl = document.createElement('div');
      this._textEl.className += 'dialog-text';
      this.el.appendChild(this._textEl);
    }

    createTitle() {
      this._titleEl = document.createElement('div');
      this._titleEl.className += 'dialog-title';
      this._titleEl.innerHTML += this.options.title;

      this._textEl.appendChild(this._titleEl);
    }

    createMessageRows() {
      if (this.options.message) {
        const textRows = this.options.message.filter(this.filterAcceptedMessages);

        if (textRows) {
          this._messageEl = document.createElement('div');
          this._messageEl.className += 'dialog-message';

          this._textEl.appendChild(this._messageEl);

          this.el.className += ' dialog-content-scrollable';
          let rowAlignProp = false;
          textRows.forEach((message, i) => {
            if (message.align) {
              rowAlignProp = true;
            }

            this._messageEl.appendChild(this.addMessageRow(message, i));
          }); 

          if (textRows.length > 1 && !rowAlignProp) {
            this.el.className += ' dialog-text-left';
          }
        }
      }
    }

    render() {
      this.createButtonWrapper();
      this.addIcon();
      this.createTextWrapper();
      this.createTitle();
      this.createMessageRows();
    }

  }

  if (__webpack_require__.g.window && window.svs) {
    window.svs = window.svs || {};
    window.svs.ui = window.svs.ui || {};
    window.svs.ui.dialog = window.svs.ui.dialog || {};
    window.svs.ui.dialog.Content = DialogContent;
  }


  const content = DialogContent;
  ; 


  const CONTEXTUAL = 'contextual';
  const POPUP = 'popup';
  const TOASTER = 'toaster';

  const constants_area = {
    CONTEXTUAL,
    POPUP,
    TOASTER
  };
  ; 


  const TUR = 'tur';
  const SPORT = 'sport';
  const NEUTRAL = 'NEUTRAL';
  const NAVY = 'navy';
  const branding_ERROR = 'ERROR';

  const branding = {
    TUR,
    SPORT,
    NEUTRAL,
    NAVY,
    ERROR: branding_ERROR
  };
  ; 


  const handshake_DEFAULT = 10000;

  const handshake = {
    DEFAULT: handshake_DEFAULT
  };
  ; 


  class DialogConfirm extends pubsub {
    constructor(options) {
      super(options);
      this.log = window.svs ? new window.svs.core.log.Logger('DialogConfirm') : console;

      if (options.type === ERROR) {
        options.branding = branding_ERROR; 

        options.icon = 'exclamation-sign';
      }

      if (!options.branding) {
        throw new Error('This component must have a branding specified.');
      }

      const defaults = {
        branding: options.branding,
        title: options.title,
        icon: 'checkmark',
        autoClose: 0,
        convertToPopup: true,
        area: POPUP,
        type: CONFIRM,
        requireHandshake: false,
        handshakeTimeout: handshake_DEFAULT,
        _ContentClass: content
      }; 

      this.options = Object.assign(defaults, options);
      this.currentHeight = undefined;
      this.requireHandshake = this.options.requireHandshake;
      this.handshakeFailsafe = undefined;
      this.handshakeTimeout = this.options.handshakeTimeout;
      this._isClosing = false;
      this._id = new Date().getTime();
      this.tl = {};
      this.render();
      this.setupAnimations();
    }

    hasRevealed() {
      this.log.debug("Dialog ".concat(this.options.title, " has revealed"));

      if (this.options.autoClose && this.type !== ERROR) {
        this.timeout = setTimeout(() => {
          this.close();
        }, this.options.autoClose);
      } else {
        clearTimeout(this.timeout);
      }

      this.emit('revealed');

      this._buttons.setFocus();

      if (this.requireHandshake) {
        this.handshakeFailsafe = setTimeout(() => {
          this.requireHandshake = false;
          this.log.debug('Handshake timed out.');
        }, this.handshakeTimeout);
      }
    }

    setupAnimations() {
      this.tl = external_gsap_default().timeline({
        paused: true,
        onComplete: () => {
          this.hasRevealed();
        },
        onReverseComplete: () => {
          this.hasClosed();

          if (typeof this.onCloseCallback === 'function') {
            setTimeout(() => {
              this.onCloseCallback();
            }, 300);
          }
        }
      });
      this.tl.fromTo(this._content.el, {
        y: -10,
        autoAlpha: 0
      }, {
        duration: 0.15,
        y: 0,
        autoAlpha: 1
      });
      this.tl.fromTo(this._buttons.el, {
        opacity: 0,
        y: 50
      }, {
        duration: 0.15,
        opacity: 1,
        y: 0
      }, '-=.1');
    }

    next() {
      this.log.debug('Open next confirm');
      this.tl.seek(0);
      this.tl.play().timeScale(2);
    }

    close(callback) {
      this._isClosing = true;

      if (callback) {
        this.onCloseCallback = callback;
      } 


      clearTimeout(this.timeout);
      clearTimeout(this.handshakeFailsafe); 

      if (this.options.area === TOASTER) {
        this.hasClosed();
      } else {
        this.tl.timeScale(2).reverse();
      }
    }

    reveal() {
      if (this.options.area === TOASTER) {
        this.tl.seek(this.tl.duration(), true);
      }

      this.tl.play();
    }

    setDimensions() {
      this.height = this.el.offsetHeight;
      this.width = this.el.offsetWidth;
    }

    hide() {
      this.el.setAttribute('style', 'display: none');
    }

    hasClosed() {
      this.log.debug('Dialog has closed');

      if (!this.requireHandshake) {
        this.emit('closed');
      }
    }

    closed() {
      this.emit('hasClosed', {});
    }

    setScrollableHeight(h) {
      if (this.currentHeight !== h) {
        if (typeof h === 'string') {
          this.el.setAttribute('style', 'height: auto;');
        } else {
          this.el.setAttribute('style', "height: ".concat(h, "px;"));
        }

        this.currentHeight = h;

        this._content.testScrollArea();
      }
    }

    setAllowDimmerClick() {
      this.allowDimmerClick = true;

      if (this.options.area === TOASTER || this.options.type === ERROR || this.options.allowDimmerClick === false || this.options.actions && this.options.actions.length >= 2) {
        this.allowDimmerClick = false;
      }
    }

    resolveHandshake() {
      clearTimeout(this.handshakeFailsafe);
      this.requireHandshake = false;
      this.close();
    }

    getContent() {
      return new this.options._ContentClass(this.options);
    }

    createWrapper() {
      this.el = document.createElement('div');
      this.el.className += 'js-dialog-item dialog-item f-content';
      this.el.setAttribute('tabindex', '-1');
    }

    addButtons() {
      this._buttons = new buttons(this.options);

      this._buttons.on('close', this, () => {
        this.close();
      });

      this._buttons.on('callback', this, _ref => {
        let {
          e,
          callback
        } = _ref;
        callback(e, this.el.getElementsByClassName('js-dialog-item-checkbox'), this);
      });

      this._buttons.on('scrollToEnd', this, () => {
        this._content.scrollToEnd();
      });

      this.el.appendChild(this._buttons.el);
    }

    addContent() {
      this._content = this.getContent();
      this.el.appendChild(this._content.el);

      this._content.on('contentScrolling', this, () => {
        this._buttons.showScrollButton();
      });

      this._content.on('contentBottom', this, () => {
        this._buttons.hideScrollButton();
      });
    }

    render() {
      this.createWrapper();

      if (this.options.type === ERROR) {
        this.el.className += ' dialog-item-error';
      }

      this.el.className += " dialog-branding-".concat(this.options.branding);
      this.addContent();
      this.addButtons();
      this.setAllowDimmerClick();
    }

  }


  const views_confirm = DialogConfirm;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).dialog = window.svs.ui.dialog || {}).Confirm = __webpack_exports__.default;
})();
 })(window);